import Model from './model';





export default Model.extend( {

    endpoint: 'stickers', responseAt: '',
    
    defaults() {
        return {
            title: '',
            cluster: null,
            description: '',
            is_for_all: 'f',
            types: [],
        };
    },

    customParser(payload) {
        const { news_type_ids, type_ids, types } = payload;
        return {
            ...payload,
            types: news_type_ids || type_ids || types || [],
        }
    }
    
} );


// WEBPACK FOOTER //
// ./src/js/model/sticker.js